import * as React from "react";
import * as ReactMarkdown from "react-markdown";

import { IProps, SimplePage } from "../../components/SimplePage/SimplePage";
import styled from "../../styled-components";
import { Header, Footer } from "@asayinc/components";

const LegalContent = styled.div`
  font-family: ${props => props.theme.fonts.sans};
  font-size: 18px;
  line-height: 1.5;
  color: ${props => props.theme.colors.black};
  a {
    color: ${props => props.theme.colors.blue};
    text-decoration: none;
  }
  blockquote {
    padding: 0 20px;
    margin-left: 0;
    white-space: pre-line;
  }
  p {
    margin: 0 0 20px 0;
    font-size: 18px;
  }
  ol.alpha-list {
    list-style-type: lower-alpha;
  }
  h3 {
    font-size: 16px;
    font-weight: 600;
    font-family: ${props => props.theme.fonts.sans};
    line-height: 16px;
    text-transform: capitalize;
    text-align: center;
    margin: 85px 0 28px 0;
    &:after {
      content: " ";
      background-color: ${props => props.theme.colors.blue};
      height: 4px;
      display: block;
      width: 50px;
      margin: 28px auto 0 auto;
    }
  }
  h4 {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    font-family: ${props => props.theme.fonts.sans};
    line-height: 16px;
    text-align: left;
    text-transform: capitalize;
  }

  ul {
    list-style-type: none;
    font-size: 18px;
    margin: 0 0 40px 0;
    li {
      padding-left: 1em;
      text-indent: -1em;
      margin: 0 0 20px 0;
      strong {
        font-weight: 600;
      }
      &::before {
        content: "•";
        padding-right: 7px;
        color: ${props => props.theme.colors.blue};
      }
    }
  }

  strong {
    font-weight: 700;
  }
`;

const Contact = LegalContent.extend`
  padding: 0 18px;
  background-color: ${props => props.theme.colors.lightGray};
`;

const InnerContact = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 18px;
  text-align: center;

  p {
    margin-bottom: 0px;
  }

  h3 {
    padding: 75px 0 0 0;
  }
`;

const ButtonWrapper = styled.div`
  margin: 15px 0 35px 0;
  display: flex;
  align-items: center;
`;

const Button = styled.a`
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.blue};
  border: 1px solid ${props => props.theme.colors.blue};
  border-radius: 4px;
  font-family: ${props => props.theme.fonts.sans};
  font-size: 14px;
  font-weight: bold;
  height: 60px;
  line-height: 60px;
  margin: 0 10px;
  text-align: center;
  text-decoration: none;
  width: 130px;

  &.active {
    background-color: ${props => props.theme.colors.blue};
    color: ${props => props.theme.colors.white};
  }
`;

const Address = styled.div`
  text-align: center;
  font-weight:
  font-size: 16px;
  line-height: 1.5;
  padding: 28px 0 85px 0;
  background-color: ${props => props.theme.colors.lightGray};
  color: ${props => props.theme.colors.black};
`;

const AddressSub = styled.p`
  margin-bottom: 8px !important;
`;

interface ILegalProps extends IProps {
  headerContent?: string;
  content?: string;
  htmlContent?: JSX.Element;
  rawContent?: any;
  headerRawContent?: any;
}

const LegalBase: React.SFC<ILegalProps> = (props: ILegalProps) => (
  <>
    <Header />
    <LegalContent>
      <SimplePage
        title="Say Privacy Policy"
        byline="Last updated: April 10, 2018"
        {...props}
      >
        <LegalContent>
          {props.content ? (
            <ReactMarkdown source={props.content} escapeHtml={false} />
          ) : (
            props.rawContent
          )}
          {props.htmlContent ? props.htmlContent : ""}
        </LegalContent>
      </SimplePage>
    </LegalContent>
    <Contact>
      <InnerContact>
        <h3>Contact us</h3>
        <p>
          To report an incident or if you have any questions about these terms
          please contact dataprivacy@saytechnologies.com or by writing us at:
        </p>
      </InnerContact>
    </Contact>
    <Address>
      <AddressSub>85 Willow Rd</AddressSub>
      <AddressSub>Menlo Park, CA 94025</AddressSub>
    </Address>
    <Footer />
  </>
);

export { Button, ButtonWrapper, ILegalProps, LegalBase };



// WEBPACK FOOTER //
// ./src/pages/Legal/Base.tsx